/* unplugin-vue-components disabled */import { render } from "./retrievePwd.vue?vue&type=template&id=1df0b173&scoped=true"
import script from "./retrievePwd.vue?vue&type=script&lang=js"
export * from "./retrievePwd.vue?vue&type=script&lang=js"

import "./retrievePwd.vue?vue&type=style&index=0&id=1df0b173&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df0b173"]])

export default __exports__